import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import { mobilecheck, isApp } from '@/utils/ua'
import '@/plugin'
import '@/plugin/release'
import '@/config/http'
import 'video.js/dist/video-js.css'
import '@/assets/style/common.scss'
import '@/assets/style/theme.scss'

Vue.config.productionTip = false
const getTopicInfo = async () => {
  let _platform = Number(topicParams._platform || 1)
  _platform = mobilecheck() ? isApp() ? 3 : 2 : _platform
  await Vue.topic.getTopic({
    code: topicParams.code,
    platform: _platform
  })
}
getTopicInfo().finally(() => {
  new Vue({
    store,
    render: h => h(App)
  }).$mount('#app')
})
